import React, { ReactElement } from 'react';
import './BillView.scss';
import { BillDetailed } from '@enview/interface/types/bills/Bill';
import { BillAlias } from '@enview/interface/types/bills/BillSummary';
import { getBillTitle } from '../../helpers/BillHelper';

type BillViewTitleProps = {
  bill: BillDetailed;
  billAlias?: BillAlias;
};

const BillViewTitle = (props: BillViewTitleProps): ReactElement => {
  const { bill, billAlias } = props;
  const { number, session } = bill;
  return (
    <header className="title">
      <span className="bill-session">{`${bill.session.state.name.toUpperCase()} - ${bill.session.displayName.toUpperCase()}`}</span>
      <br />
      <h1 className="bill-title">{getBillTitle(session, number, billAlias)}</h1>
    </header>
  );
};

export default BillViewTitle;
